// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Fira Sans', 'Fira Sans Fallback'"},"className":"__className_a753a1","variable":"__variable_a753a1"};